import axiosInstance from "../../api/axiosInstance";
import {
  getMpczDeleteAccountByMobile,
  getMpczComplaintStatus,
  getMpczLinkMobileNumber,
  getMpczRegisterComplaint,
  getMpczSendOtp,
  getMpczSaralSanyojanTrackApplication,
  getMpczSolarRooftopTrackApplication,
  getMpczVerifyOtp,
  getMpczHtConsumerInfo,
  getMpczIvrsVerifyConsumer,
  getMpczHtUpdateAlternativeContact,
} from "../../utills/constants";

export const MPCZ_REGISTER_COMPLAINT_REQUEST = "MPCZ_REGISTER_COMPLAINT_REQUEST";
export const MPCZ_REGISTER_COMPLAINT_SUCCESS = "MPCZ_REGISTER_COMPLAINT_SUCCESS";
export const MPCZ_REGISTER_COMPLAINT_FAILURE = "MPCZ_REGISTER_COMPLAINT_FAILURE";
export const MPCZ_REGISTER_COMPLAINT_CLEAR = "MPCZ_REGISTER_COMPLAINT_CLEAR";
export const MPCZ_COMPLAINT_STATUS_REQUEST = "MPCZ_COMPLAINT_STATUS_REQUEST";
export const MPCZ_COMPLAINT_STATUS_SUCCESS = "MPCZ_COMPLAINT_STATUS_SUCCESS";
export const MPCZ_COMPLAINT_STATUS_FAILURE = "MPCZ_COMPLAINT_STATUS_FAILURE";
export const MPCZ_COMPLAINT_STATUS_CLEAR = "MPCZ_COMPLAINT_STATUS_CLEAR";

export const mpczRegisterComplaintRequest = () => ({ type: MPCZ_REGISTER_COMPLAINT_REQUEST });
export const mpczRegisterComplaintSuccess = (payload) => ({
  type: MPCZ_REGISTER_COMPLAINT_SUCCESS,
  payload,
});
export const mpczRegisterComplaintFailure = (payload) => ({
  type: MPCZ_REGISTER_COMPLAINT_FAILURE,
  payload,
});
export const clearMpczRegisterComplaintData = () => ({ type: MPCZ_REGISTER_COMPLAINT_CLEAR });
export const mpczComplaintStatusRequest = () => ({ type: MPCZ_COMPLAINT_STATUS_REQUEST });
export const mpczComplaintStatusSuccess = (payload) => ({
  type: MPCZ_COMPLAINT_STATUS_SUCCESS,
  payload,
});
export const mpczComplaintStatusFailure = (payload) => ({
  type: MPCZ_COMPLAINT_STATUS_FAILURE,
  payload,
});
export const clearMpczComplaintStatusData = () => ({ type: MPCZ_COMPLAINT_STATUS_CLEAR });

export const mpczRegisterComplaint = (payload) => async (dispatch) => {
  dispatch(mpczRegisterComplaintRequest());
  try {
    const body = {
      mobile_no: String(payload.mobile_no ?? "").trim(),
      ivrs: String(payload.ivrs ?? "").trim(),
      subcat: Number(payload.subcat ?? 2),
      comment: String(payload.comment ?? "").trim(),
    };
    const response = await axiosInstance.post(getMpczRegisterComplaint(), body);
    const data = response?.data;
    if (!data || String(data.status || "").toLowerCase() !== "success") {
      throw new Error(data?.message || "Complaint registration failed.");
    }
    dispatch(mpczRegisterComplaintSuccess(data));
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    dispatch(mpczRegisterComplaintFailure(message));
    throw new Error(message);
  }
};

export const mpczGetComplaintStatus = (payload) => async (dispatch) => {
  dispatch(mpczComplaintStatusRequest());
  try {
    const body = {
      complaint_number: String(payload.complaint_number ?? "").trim(),
      category: String(payload.category ?? "1").trim(),
    };
    const response = await axiosInstance.post(getMpczComplaintStatus(), body);
    const data = response?.data;
    if (!data || String(data.status || "").toLowerCase() !== "success") {
      throw new Error(data?.message || "Complaint status fetch failed.");
    }
    dispatch(mpczComplaintStatusSuccess(data));
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    dispatch(mpczComplaintStatusFailure(message));
    throw new Error(message);
  }
};

export const mpczLinkMobileNumber = (payload) => async () => {
  try {
    const body = {
      mobile_no: String(payload.mobile_no ?? "").trim(),
      id_type: "ccnb",
      id_number: String(payload.id_number ?? "").trim(),
      user_type: String(payload.user_type ?? "consumer").trim(),
    };
    const response = await axiosInstance.post(getMpczLinkMobileNumber(), body);
    const data = response?.data;
    if (!data || String(data.status || "").toLowerCase() !== "success") {
      throw new Error(data?.message || "Link mobile number failed.");
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const mpczVerifyIvrsConsumer = (payload) => async () => {
  try {
    const body = {
      consumer_number: String(payload.consumer_number ?? "").trim(),
      mobile_no: String(payload.mobile_no ?? "").trim(),
      user_type: String(payload.user_type ?? "lt").trim(),
    };
    const response = await axiosInstance.post(getMpczIvrsVerifyConsumer(), body);
    const data = response?.data;
    const isSuccess =
      String(data?.status || "").toLowerCase() === "success" || Number(data?.error_code) === 0;
    if (!data || !isSuccess) {
      throw new Error(data?.message || "Failed to verify consumer.");
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const mpczDeleteAccountByMobile = (payload) => async () => {
  try {
    const mobileNumber = String(payload.mobile_no ?? "").trim();
    const body = {
      mobile_no: mobileNumber,
      source: String(payload.source ?? "Chatbot").trim(),
      consumer_number: String(payload.consumer_number ?? "").trim(),
      user_type: String(payload.user_type ?? "LT").trim(),
    };
    const response = await axiosInstance.post(getMpczDeleteAccountByMobile(), body, {
      headers: {
        "whatsapp-account": mobileNumber,
        "Accept-Language": String(payload.acceptLanguage ?? "en").trim(),
      },
    });
    const data = response?.data;
    if (!data || String(data.status || "").toLowerCase() !== "success") {
      throw new Error(data?.message || "Delete account by mobile failed.");
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const mpczSendOtp = (payload) => async () => {
  try {
    const mobileNumber = String(payload?.mobile_no ?? "").trim();
    const body = {
      mobile_no: mobileNumber,
      source: String(payload?.source ?? "Test App"),
    };
    const response = await axiosInstance.post(getMpczSendOtp(), body, {
      headers: {
        "whatsapp-account": mobileNumber,
      },
    });
    const data = response?.data;
    if (!data || String(data.status || "").toLowerCase() !== "success") {
      throw new Error(data?.message || "Failed to send OTP.");
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const mpczVerifyOtp = (payload) => async () => {
  try {
    const mobileNumber = String(payload?.mobile_no ?? "").trim();
    const body = {
      mobile_no: mobileNumber,
      source: String(payload?.source ?? "Test App"),
      otp: String(payload?.otp ?? "").trim(),
    };
    const response = await axiosInstance.post(getMpczVerifyOtp(), body, {
      headers: {
        "whatsapp-account": mobileNumber,
      },
    });
    const data = response?.data;
    if (!data || String(data.status || "").toLowerCase() !== "success") {
      throw new Error(data?.message || "Failed to verify OTP.");
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const mpczTrackSaralSanyojanApplication = (payload) => async () => {
  try {
    const headers = {
      "whatsapp-account": String(payload?.whatsapp_account ?? "").trim(),
      "search-value": String(payload?.search_value ?? "").trim(),
      "Application-Number": String(payload?.application_number ?? "").trim(),
    };
    const response = await axiosInstance.get(getMpczSaralSanyojanTrackApplication(), { headers });
    const data = response?.data;
    if (!data || String(data.status || "").toLowerCase() !== "success") {
      throw new Error(data?.message || "Track application failed.");
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const mpczTrackSolarRooftopApplication = (payload) => async () => {
  try {
    const headers = {
      "whatsapp-account": String(payload?.whatsapp_account ?? "").trim(),
      "search-value": String(payload?.search_value ?? "").trim(),
      "Application-Number": String(payload?.application_number ?? "").trim(),
    };
    const response = await axiosInstance.get(getMpczSolarRooftopTrackApplication(), { headers });
    const data = response?.data;
    if (!data || String(data.status || "").toLowerCase() !== "success") {
      throw new Error(data?.message || "Track application failed.");
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const mpczGetHtConsumerInfo = (consumerNumber) => async () => {
  try {
    const response = await axiosInstance.get(getMpczHtConsumerInfo(consumerNumber));
    const data = response?.data;
    const isSuccess =
      String(data?.status || "").toLowerCase() === "success" || Number(data?.error_code) === 0;
    if (!data || !isSuccess) {
      throw new Error(data?.message || "Failed to fetch HT consumer information.");
    }
    const consumerInfo = Array.isArray(data?.data) ? data.data[0] : data?.data;
    if (!consumerInfo || typeof consumerInfo !== "object") {
      throw new Error("Consumer information not found.");
    }
    return consumerInfo;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

const toApiMobileValue = (value) => {
  const text = String(value ?? "").trim();
  if (!text || text.toUpperCase() === "NA") return "";
  return text.replace(/\D/g, "").slice(0, 10);
};

export const mpczUpdateHtConsumerInfo = (payload) => async () => {
  try {
    const consumerNumber = String(payload.consumer_number ?? payload.customerId ?? "").trim();
    if (!consumerNumber) {
      throw new Error("Consumer number is required.");
    }

    const body = { consumer_number: consumerNumber };

    const mobileFields = [
      ["alternative_mobile", payload.alternative_mobile ?? payload.alternativeMobile],
      ["alternative_mobile2", payload.alternative_mobile2 ?? payload.alternativeMobile2],
      ["alternative_mobile3", payload.alternative_mobile3 ?? payload.alternativeMobile3],
      ["alternative_mobile4", payload.alternative_mobile4 ?? payload.alternativeMobile4],
    ];

    mobileFields.forEach(([key, value]) => {
      const mobile = toApiMobileValue(value);
      if (mobile) body[key] = mobile;
    });

    const primaryEmail = String(payload.primary_email ?? payload.email ?? "").trim();
    if (primaryEmail) body.primary_email = primaryEmail;

    const alternativeEmail = String(payload.alternative_email ?? payload.alternativeEmailId ?? "").trim();
    if (alternativeEmail) body.alternative_email = alternativeEmail;

    body.update_alternate_email = Boolean(alternativeEmail);

    const response = await axiosInstance.post(getMpczHtUpdateAlternativeContact(), body);
    const data = response?.data;
    const isSuccess =
      String(data?.status || "").toLowerCase() === "success" || Number(data?.error_code) === 0;
    if (!data || !isSuccess) {
      throw new Error(data?.message || "Failed to update HT consumer information.");
    }
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};
